import { render, staticRenderFns } from "./AdminPages.vue?vue&type=template&id=70f5ff36&scoped=true&"
import script from "./AdminPages.vue?vue&type=script&lang=js&"
export * from "./AdminPages.vue?vue&type=script&lang=js&"
import style0 from "./AdminPages.vue?vue&type=style&index=0&id=70f5ff36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f5ff36",
  null
  
)

export default component.exports